/**
 * Constants for claim keys from the identity provider
 * Centralized management of all claim key strings used throughout the application
 */
export class ClaimKeys {
  // User identification claims
  static readonly SUB = "sub";
  static readonly EMAIL = "email";
  static readonly NAME = "name";
  static readonly GIVEN_NAME = "given_name";
  static readonly FAMILY_NAME = "family_name";
  static readonly USER_TYPE = "user_type";

  // Customer/Organization claims
  static readonly CUSTOMER_ID = "cid";
  static readonly CUSTOMER_NAME = "cnm";

  // Impersonation claims
  static readonly IMPERSONATED_USER_ID = "imp_uid";
  static readonly ACTING_USER_EMAIL = "act_email";
  static readonly ACTING_USER_NAME = "act_name";

  // Session claims
  static readonly LOGOUT_URL = "bff:logout_url";
  static readonly SESSION_EXPIRES_IN = "bff:session_expires_in";
  static readonly SESSION_STATE = "bff:session_state";

  // Additional claims
  static readonly SESSION_ID = "sid";
  static readonly AUTH_TIME = "auth_time";
  static readonly IDP = "idp";
  static readonly AMR = "amr";
}
